<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div v-if="tadd == 1">
        <div style="margin-bottom: 1px">
          <!-- <el-button @click="modals">生成临时费用</el-button> -->
          <el-button @click="add_list">新增临时收费</el-button>
          <el-button @click="searchs">搜索</el-button>
          <el-button @click="download">导出</el-button>
        </div>
        <div style="width: 99%; margin-top: 10px">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="项目">
              {{ house_name }}
            </el-descriptions-item>
            <el-descriptions-item label="收费项目">
              <el-select v-model="chargeitemID" size="mini" multiple filterable collapse-tags style="width: 100%" placeholder="收费项目">
                <el-option  v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="房产">
              <el-select v-model="text" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产/客户姓名" :remote-method="remoteMethod" :loading="loading" style="width: 100%">
                <el-option
                  v-for="item in selectList"
                  :key="item.id"
                  :label="item.house"
                  :value="item.house"
                ></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="查询模式">
              <el-radio v-model="searchMode" label="1">模糊查询</el-radio>
              <el-radio v-model="searchMode" label="2">精确查询</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="业户">
              <el-input v-model="user" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="票据号">
              <el-input v-model="billNo" size="mini"></el-input>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="缴费日期">
              <el-date-picker v-model="operatorStartDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="operatorEndDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-table ref="multipleTable" height="55vh" :data="data" border style="width: 99%; margin-top: 10px">
          <el-table-column label="操作" width="100">
            <template slot-scope="data">
              <el-button style="color: #574cfd;" type="text" @click="editPaymentName(data.row)">修改</el-button>
              <!-- <el-button style="color: #574cfd;" type="text" @click="billPrintClick(data.row)">打印</el-button> -->
              <el-button style="color: #574cfd;" type="text" @click="del(data.row.id)" v-if="ERP.isPermission(4003008002)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="h_name" label="业户" width="100"></el-table-column>
          <el-table-column prop="address" label="房产"></el-table-column>
          <el-table-column prop="charge_name" label="临时费用名称"></el-table-column>
          <el-table-column prop="charge" label="金额" width="100"></el-table-column>
          <el-table-column prop="payment_number" label="缴款方式" width="100"></el-table-column>
          <el-table-column label="计费周期">
            <template slot-scope="scope">
              {{scope.row.startDate}} - {{scope.row.endDate}}
            </template>
          </el-table-column>
          <el-table-column prop="bill_number" label="票据号" width="110"></el-table-column>
          <el-table-column prop="user" label="操作人" width="100"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column prop="date" label="操作时间" width="140"></el-table-column>
        </el-table>
        <v-divider></v-divider>
        <div class="pages" v-if="data">
          <Page
            :total="count"
            :page-size="pageSize"
            @on-change="change"
            show-total
          />
        </div>
        <div class="zhanwu" v-else>没有数据</div>
      </div>
      <t-add ref="tadds" @top="top" v-if="tadd == 2"></t-add>
    </div>

    <Modal
      v-model="modal4"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      title="修改"
      @on-ok="alterPaymentName"
    >
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>缴款方式</span>
            <div class="cdj_input">
              <el-select
                style="width: 100%"
                v-model="form.payment_number"
                filterable
                placeholder="缴款方式"
                class="kuan"
              >
                <el-option
                  v-for="item in payment"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>备注</span>
            <div class="cdj_input">
              <el-input
                v-model="form.remarks"
                placeholder="请输入备注"
              ></el-input>
            </div>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 导入 -->
    <Modal
      v-model="modal"
      :styles="{top: '20px'}"
      ok-text="确定导入(已付款)"
      width="1000"
      :loading="loadingModal"
      :mask="maskclosable"
      title="临时费用添加"
      @on-ok="add"
    >
      <div>
        <el-form style="height: 600px; overflow: auto;width: 60%;margin-left: 20%;">
          <div>
            <span><span class="cdj_span">*</span>客户姓名</span>
            <div style="display: flex;">
              <el-select v-model="form.cname" clearable placeholder="客户姓名" class="cdj_input cdj_el_select">
                  <el-option
                    v-for="item in form.user"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              <el-button class="cdj_input" @click="updates">选择客户</el-button>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>选择项目</span>
            <div class="cdj_input">
              <el-select
                v-model="form.pindex_id"
                filterable
                placeholder="请选项目"
                class="cdj_el_select"
              >
                <el-option
                  v-for="item in options"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>选择房产（可搜索房产/或点击左边房产树）</span>
            <div class="cdj_input">
              <el-select
                v-model="form.house_id"
                :remote-method="remoteMethods"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="可搜索房产/或点击左边房产树"
                class="cdj_el_select"
              >
                <el-option
                  v-for="item in house"
                  :key="item.house_id"
                  :label="item.house"
                  :value="item.house_id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>选择费项名称</span>
            <div class="cdj_input">
              <el-select
                v-model="form.charge_id"
                filterable
                placeholder="请选费项名"
                class="cdj_el_select"
              >
                <el-option
                  v-for="item in charge"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>收费方式</span>
            <div class="cdj_input">
              <el-select
                v-model="form.payment_number"
                filterable
                placeholder="收费方式"
                class="cdj_el_select"
              >
                <el-option
                  v-for="item in payment"
                  :key="item.number"
                  :label="item.name"
                  :value="item.number"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>收费金额</span>
            <el-input
              class="cdj_input"
              v-model="form.charge"
              placeholder="请输入收费金额"
            ></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>费用周期</span>
            <div class="cdj_margin_span">
              <el-date-picker
                v-model="form.dates"
                type="daterange"
                :unlink-panels="unlinkpanels"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>备注</span>
            <el-input
              type="textarea"
              class="cdj_input"
              v-model="form.text"
              placeholder="备注"
            ></el-input>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 打印display: none; -->
    <div
      style="
        position: absolute;
        bottom: 100px;
        left: 500px;
        width: 700px;
        display: none;
      "
    >
      <div id="printBill">
        <div style="font-size: 8px; color: #141414; font-family: 楷体">
          <div
            style="
              width: 100%;
              text-align: center;
              margin-top: 30px;
              font-size: 20px;
            "
          >
            中奥物业 收款收据
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 70%">房号：{{ deposit.address }}</div>
            <div style="width: 30%; margin-left: 220px">
              付款方式：{{ deposit.payment_number }}
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">业主：{{ deposit.h_name }}</div>
            <div style="width: 33%">收据单号：{{ deposit.bill_number }}</div>
            <div style="width: 34%; text-align: right; margin-right: 25px">
              开票日期：{{ deposit_date }}
            </div>
          </div>
          <div style="margin-top: 1px; line-height: 17px">
            <table
              align="center"
              style="width: 100%; border-collapse: collapse"
            >
              <tr>
                <th
                  style="border: 1px solid #000000; width: 150px"
                  align="center"
                  valign="middle"
                >
                  收费项目
                </th>
                <th
                  style="border: 1px solid #000000; width: 200px"
                  align="center"
                  valign="middle"
                >
                  收取日期
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  class="ddd"
                  align="center"
                  valign="middle"
                >
                  面积
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  数量
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  收取金额
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  退还金额
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  金额
                </th>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.charge_name }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.startDate }}-{{ deposit.endDate }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                ></td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  1
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.charge }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  0.00
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.charge }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  合计（大写）：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="4"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ capitalize }}</span>
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  （小写）：
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ deposit.charge }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  备注：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="6"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ deposit.remarks }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 70%; margin-top: 20px">
            说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">开票人：{{ login }}</div>
            <div style="width: 33%">收款人：{{ deposit.user }}</div>
            <div style="width: 34%; text-align: right; margin-right: 94px">
              收款单位（盖章）
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%"></div>
            <div style="width: 33%"></div>
            <div style="width: 34%; text-align: right; margin-right: 70px">
              打印时间：{{ deposit_date }}
            </div>
          </div>
          <div style="text-align: center; margin-top: 7px">
            打印次数<span style="margin-left: 30px">{{
              deposit.frequency
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house_1"></room-user>
      </div>
    </Modal>
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import print from "print-js";
export default {
  name: "OrderTemporary",
  data() {
    return {
      user:'',
      chargeitemID:'',
      chargeitem:[],
      tadd:1,
      maskclosable:false,
      modal1:false,
      house_1:'',
      house_name: "",
      project_id: "",
      selectList: [],
      modal: false,
      modal4: false,
      statesModal: false,
      loading: false,
      loadingModal: true,
      unlinkpanels: true,
      options: [],
      payment: [],
      charge: [],
      house: [],
      count: 0,
      pageSize: 12,
      data: [],
      pid: "",
      text: "",
      state: "1",
      url: "",
      fileList: [],
      form: {
        pindex_id: "",
        charge: "",
        text: "",
        charge_id: "",
        house_id: "",
        dates: "",
        payment_number: "",
        remarks: "",
        cname:"",
        user:[],
      },
      statesForm: {
        id: "",
        stutes: "",
        remarks: "",
      },
      capitalize: "",
      deposit_date: "",
      deposit: [],
      login: "",
      billNo: "",
      searchMode: "1",
      startDate : '',
      endDate : '',
      operatorStartDate : '',
      operatorEndDate : '',
    };
  },
  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
    "room-user": () => import('../Common/room-user.vue'),
    "t-add": () => import('./temporary/add.vue')
  },
  created() {
    let house = this.$route.query.house;
    let user_id = this.$route.query.user_id;
    let pid = this.$route.query.pid;
    let pid_house = this.$route.query.pid_house;
    // if(house){
    //   this.text = house;
    //   this.form.house_id = house;
    //   this.form.pindex_id = pid_house;
    //   this.pid = pid;
    //   this.$myhttp.get("admin/Temporary/temporary_user?id="+user_id, {
    //       "Content-Type": "application/json",
    //   }).then((backdata) => {
    //     this.form.user = backdata.data.data;
    //     this.form.cname = backdata.data.data[0].name;
    //   });
    //   this.modal = true;
    // }else{
    //   if(pid_house){
    //     this.text = pid_house;
    //     this.form.pindex_id = pid_house;
    //     this.form.house_id = pid_house;
    //     this.pid = pid;
    //     this.modal = true;
    //   }
    // }
    if(house){
      window.localStorage.setItem("house", house);
      window.localStorage.setItem("project_id", pid);
      this.tadd = 2;
    }

  },
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
    //项目列表
    this.$myhttp.get("admin/common/pindex", {
        "Content-Type": "application/json",
    }).then((backdata) => {
      this.options = backdata.data.data;
    });
    this.change(1);
    //加载收款方式
    this.$myhttp
      .get("admin/common/payment", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.payment = backdata.data.data;
      });
      //加载收费大类（费项）
      this.$myhttp.get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
      }).then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  methods: {
    //新增
    add_list(){
      if(this.project_id == ""){
        this.$Message.error("请选择一个项目!");
        return false;
      }
      this.tadd = 2;
      window.localStorage.setItem("house", this.text);
      window.localStorage.setItem("project_id", this.project_id);
    },
    top(){
      this.tadd = 1;
    },
    billPrintClick(item) {
      this.login = window.localStorage.getItem("login");
      this.$myhttp
        .post("admin/Temporary/getTemporay", item, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.deposit = backdata.data.data;
          let money = this.deposit.charge;
          this.capitalize = this.transCnMoney(money);
          this.deposit_date = backdata.data.deposit_date;
          this.day();
        });
    },
    //打印
    day() {
      let _this = this;
      setTimeout(function () {
        const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
        printJS({
          printable: "printBill", // 标签元素id
          type: "html",
          header: "",
          targetStyles: ["*"],
          scanStyles: false, //打印必须加上，不然页面上的css样式无效
          style,
        });
      }, 100);
    },
    //数字转大写
    transCnMoney(number) {
      var CN_MONEY = "";
      var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
      number = parseFloat(number).toFixed(2).toString(); //浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
      var dot = number.indexOf("."); //将从小数点开始分开
      if (dot >= 0) {
        number = number.substring(0, dot) + number.substr(dot + 1, 2);
        CN_UNIT = CN_UNIT.substr(CN_UNIT.length - number.length);
        for (var i = 0; i < number.length; i++) {
          CN_MONEY +=
            "零壹贰叁肆伍陆柒捌玖".substr(number.substr(i, 1), 1) +
            CN_UNIT.substr(i, 1);
        }
        return CN_MONEY.replace(/零角零分$/, "整")
          .replace(/零[仟佰拾]/g, "零")
          .replace(/零{2,}/g, "零")
          .replace(/零([亿|万])/g, "$1")
          .replace(/零+元/, "元")
          .replace(/亿零{0,3}万/, "亿")
          .replace(/^元/, "零元");
      } else {
      }
    },

    //远程搜索
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //搜索房产
    remoteMethods(query) {
      // console.log(query);
      this.loading = true;
      this.$myhttp
        .get(
          "admin/common/cdj_house_text2?text=" +
            query +
            "&project_id=" +
            this.form.pindex_id,
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.house = backdata.data.data;
        });
    },
    //树搜索
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      this.pid = project.pindex_id;
      this.house_name = project.name;
      //console.log(project.name);
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.text = tree_str;
      this.form.house_id = tree_str;
      if(this.tadd == 2){
        this.$refs.tadds.pids(this.project_id,this.text);
      }
      this.change(1);
      let tree = data.tree;
      // console.log(tree)
      this.form.pindex_id = tree[0].name;
      let _this = this;
      tree.forEach(function (it) {
        if (it.type == "room") {
          // _this.form.house_id = it.superior;
          _this.remoteMethods(it.name);
        }
      });
    },
    modals() {
      this.modal = true;
    },
    //导入
    add() {
      if (this.form.pindex_id == "") {
        this.$Message.error("项目不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.charge_id == "") {
        this.$Message.error("费项名称不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.house_id == "") {
        this.$Message.error("房产不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.payment_number == "") {
        this.$Message.error("收款方式不能为空!");
        this.loadingModals();
        return false;
      }
      if (this.form.charge == "") {
        this.$Message.error("金额不能为空!");
        this.loadingModals();
        return false;
      }
      if (
        this.form.dates != null &&
        this.form.dates[0] != NaN &&
        this.form.dates[0] != "" &&
        this.form.dates[0] != null
      ) {
        var d = this.form.dates[0]; //开始时间
        var e = this.form.dates[1]; //结束时间
        this.form.dates[0] = new Date(d).getTime() / 1000;
        this.form.dates[1] = new Date(e).getTime() / 1000;
      } else {
        this.$Message.error("请选择生成时间范围!");
        this.loadingModals();
        return false;
      }
      if(this.form.cname == ""){
        this.form.user = [];
      }
      this.$myhttp
        .post("admin/Temporary/add", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.modal = false;
          if (backdata.data.code == 200) {
            this.form.charge = '';
            this.form.text = '';
            this.fileList = [];
            this.modal = false;
            this.change(1);
            this.$Message.success("提交成功!");
          } else {
            this.$Message.error("提交失败!");
          }
        });
    },

    //分页
    change(page) {
      this.loading = true;
      this.loading = false;
      let chargeitemID = '';
      if(this.chargeitemID.length >=1){
        chargeitemID = this.chargeitemID.map(req=>{return req;}).join(',');
      }
      let data = {
          'page':page,
          'state':this.state,
          'text':this.text,
          'pid':this.pid,
          'billNo':this.billNo,
          'searchMode':this.searchMode,
          'chargeitemID':chargeitemID,
          'user':this.user,
          'startDate' :this.startDate,
          'endDate' :this.endDate,
          'operatorStartDate' :this.operatorStartDate,
          'operatorEndDate' :this.operatorEndDate,
      }
      this.$myhttp.post("admin/Temporary/index", data, {
            "Content-Type": "application/x-www-form-urlencoded",
        }).then((backdata) => {
          if(backdata.code == 500){
            this.$Message.error(backdata.data.message);
          }else{
            let data = backdata.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
        this.loading = false;
      });

    },
    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
    },
    //生成
    del(id) {
      this.$confirm("删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$myhttp
            .post(
              "admin/Temporary/del",
              { id: id },
              {
                "Content-Type": "application/x-www-form-urlencoded",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data.code == 200) {
                this.change(1);
                this.$Message.success(backdata.data.message);
              } else {
                this.loading = false;
                this.$Message.error(backdata.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //弹窗不要关闭
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    editPaymentName(it) {
      this.form = {
        id: it.id,
        pindex_id: "",
        charge: "",
        text: "",
        charge_id: "",
        house_id: "",
        dates: "",
        payment_number: it.payment_number,
        remarks: it.remarks,
      };
      this.modal4 = true;
    },
    alterPaymentName() {
      if (this.form.payment_number == "") {
        this.$Message.error("缴款方式不能为空!");
        this.loadingModals();
        return false;
      }
      this.loading = true;
      this.$myhttp
        .post("admin/Temporary/editPaymentNumber", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            // 异步执行成功后
            this.loadingModals();
            this.loading = false;
            this.$Message.success("操作成功!");
            this.change(1);
            this.modal4 = false;
          } else {
            this.loadingModals();
            this.loading = false;
            this.$Message.error(backdata.data.msg);
            this.modal4 = false;
          }
        });
    },
    //选择客户
    updates(){
      this.house_1 = this.text;
      this.modal1 = true;
    },
    roomUser(){
      let user = this.$refs.child.getUser();
      //console.log(user);
      if(user.id){
        this.form.user = [user];
        this.form.cname = user.name;
      }
    },
    download(){
      let chargeitemID = '';
      if(this.chargeitemID.length >=1){
        chargeitemID = this.chargeitemID.map(req=>{return req;}).join(',');
      }
      let data = {
        'state':this.state,
        'text':this.text,
        'pid':this.pid,
        'billNo':this.billNo,
        'searchMode':this.searchMode,
        'chargeitemID':chargeitemID,
        'user':this.user,
        'startDate' :this.startDate,
        'endDate' :this.endDate,
        'operatorStartDate' :this.operatorStartDate,
        'operatorEndDate' :this.operatorEndDate,
      }
      this.$myhttp.post("admin/Temporary/download", data, {
        "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
        if(backdata.code == 500){
          this.$Message.error(backdata.data.message);
        }else{
          let url = backdata.data.data.url;
          window.open(this.$myhttp.defaults.baseURL + url, "_blank")
        }
      });

    },

  },
  watch: {
    "form.pindex_id"(pid) {
      console.log(pid);
      if (pid != "") {
        this.$myhttp
          .get("admin/Temporary/getCharge?pid=" + pid, {
            "Content-Type": "application/json",
        })
        .then((backdata) => {
            this.charge = backdata.data.data;
            this.form.charge_id = '';
        });
      }
    },
  },
};
</script>
<style>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/temporary.vue